<template>
   <div class="ecl-form-group mt-5">
    <label for="select-default" class="ecl-form-label">{{ label }}</label>
      <slot></slot>
    <div class="ecl-select__container selector">
      <select class="ecl-select" id="select-default" required="" v-model="selected">
        <option v-for="level in shaclLevels" :value="level.technicalModel" :key="level.id">{{ level.name }}</option>
      </select>
      <div class="ecl-select__icon dd-icon">
        <svg class="ecl-icon ecl-icon--s ecl-icon--rotate-180 ecl-select__icon-shape" focusable="false" aria-hidden="true">
          <use xlink:href="@/../node_modules/@ecl/preset-ec/dist/images/icons/sprites/icons.svg#corner-arrow" />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { config as CONFIG } from '../../../config/config';

export default {
    name: 'ECShaclLevel',
    props: {
        label: String,
        text: String,
    },
    data() {
        return { 
            shaclLevels :  CONFIG.shaclLevels,
            selected: CONFIG.shaclLevels[0].technicalModel,
        }
    },
    watch: {
      selected() {
        this.$store.dispatch('violations/setShapeModel', this.selected);
      }
    },
    created() {
      this.$store.dispatch('violations/setShapeModel', this.selected)
    }
}
</script>

<style scoped>
</style>